import { registerDesktopAlert } from 'common/notification-tray/desktop-alert-registry/DesktopAlertRegistry';
import { ReviewDesktopAlert } from 'common/notification-tray/desktop-alert-types/review-desktop-alert/ReviewDesktopAlert';
import { MissingProfileDataModal } from 'directory/listings/notification-modals/notifications';

/**
 * ProAct Component Registry
 *
 * This is the SINGLE place where all desktop alert components must be registered.
 * Teams should NOT call registerDesktopAlert directly elsewhere.
 */

// Review Alert
registerDesktopAlert('ElasticReview', {
    loader: async () => ({ default: ReviewDesktopAlert }),
    actionLabelKey: 'DRAFT_RESPONSE',
    icon: 'icon-star',
});

registerDesktopAlert('FieldsMissingOnProfiles', {
    loader: async () => ({ default: MissingProfileDataModal }),
    actionLabelKey: 'ACT_ON_ALL',
    icon: 'icon-bell',
});
